export const CUSTOMER_LIST_REQUEST = 'CUSTOMER_LIST_REQUEST';
export const CUSTOMER_LIST_REQUEST_SUCCESS = 'CUSTOMER_LIST_REQUEST_SUCCESS';
export const CUSTOMER_LIST_REQUEST_ERROR = 'CUSTOMER_LIST_REQUEST_ERROR';

export const CUSTOMER_SEARCH = 'CUSTOMER_SEARCH';
export const CUSTOMER_SEARCH_SUCCESS = 'CUSTOMER_SEARCH_SUCCESS';
export const CUSTOMER_SEARCH_ERROR = 'CUSTOMER_SEARCH_ERROR';
export const CUSTOMER_SEARCH_LIST_CLEAR = 'CUSTOMER_SEARCH_LIST_CLEAR';

export const CUSTOMER_ADD = 'CUSTOMER_ADD';
export const CUSTOMER_ADD_SUCCESS = 'CUSTOMER_ADD_SUCCESS';
export const CUSTOMER_ADD_ERROR = 'CUSTOMER_ADD_ERROR';

export const CUSTOMER_UPDATE = 'CUSTOMER_UPDATE';
export const CUSTOMER_UPDATE_SUCCESS = 'CUSTOMER_UPDATE_SUCCESS';
export const CUSTOMER_UPDATE_ERROR = 'CUSTOMER_UPDATE_ERROR';

export const CUSTOMER_REMOVE = 'CUSTOMER_REMOVE';
export const CUSTOMER_REMOVE_SUCCESS = 'CUSTOMER_REMOVE_SUCCESS';
export const CUSTOMER_REMOVE_ERROR = 'CUSTOMER_REMOVE_ERROR';

export const CUSTOMER_REQUEST = 'CUSTOMER_REQUEST';
export const CUSTOMER_REQUEST_SUCCESS = 'CUSTOMER_REQUEST_SUCCESS';
export const CUSTOMER_REQUEST_ERROR = 'CUSTOMER_REQUEST_ERROR';

export const CUSTOMER_LIST_EXPORT = 'CUSTOMER_LIST_EXPORT';
export const CUSTOMER_LIST_EXPORT_SUCCESS = 'CUSTOMER_LIST_EXPORT_SUCCESS';
export const CUSTOMER_LIST_EXPORT_ERROR = 'CUSTOMER_LIST_EXPORT_ERROR';

export const CUSTOMER_CHANGE_STATUS_REQUEST = 'CUSTOMER_CHANGE_STATUS_REQUEST';
export const CUSTOMER_CHANGE_STATUS_REQUEST_SUCCESS = 'CUSTOMER_CHANGE_STATUS_REQUEST_SUCCESS';
export const CUSTOMER_CHANGE_STATUS_REQUEST_ERROR = 'CUSTOMER_CHANGE_STATUS_REQUEST_ERROR';

export const CUSTOMER_DOCUMENT_DOWNLOAD = 'CUSTOMER_DOCUMENT_DOWNLOAD';
export const CUSTOMER_DOCUMENT_DOWNLOAD_SUCCESS = 'CUSTOMER_DOCUMENT_DOWNLOAD_SUCCESS';
export const CUSTOMER_DOCUMENT_DOWNLOAD_ERROR = 'CUSTOMER_DOCUMENT_DOWNLOAD_ERROR';

export const CUSTOMER_UPLOAD_IMAGE = 'CUSTOMER_UPLOAD_IMAGE';
export const CUSTOMER_UPLOAD_IMAGE_SUCCESS = 'CUSTOMER_UPLOAD_IMAGE_SUCCESS';
export const CUSTOMER_UPLOAD_IMAGE_ERROR = 'CUSTOMER_UPLOAD_IMAGE_ERROR';

export const CUSTOMER_INCREASE_LIMIT = 'CUSTOMER_INCREASE_LIMIT';
export const CUSTOMER_INCREASE_LIMIT_SUCCESS = 'CUSTOMER_INCREASE_LIMIT_SUCCESS';
export const CUSTOMER_INCREASE_LIMIT_ERROR = 'CUSTOMER_INCREASE_LIMIT_ERROR';

export const CUSTOMER_DOWNLOAD_CREDIT_DATABASE = 'CUSTOMER_DOWNLOAD_CREDIT_DATABASE';
export const CUSTOMER_DOWNLOAD_CREDIT_DATABASE_SUCCESS =
  'CUSTOMER_DOWNLOAD_CREDIT_DATABASE_SUCCESS';
export const CUSTOMER_DOWNLOAD_CREDIT_DATABASE_ERROR = 'CUSTOMER_DOWNLOAD_CREDIT_DATABASE_ERROR';

export const CUSTOMER_UPDATE_CONTRACT_DATE = 'CUSTOMER_UPDATE_CONTRACT_DATE';
export const CUSTOMER_UPDATE_CONTRACT_DATE_SUCCESS = 'CUSTOMER_UPDATE_CONTRACT_DATE_SUCCESS';
export const CUSTOMER_UPDATE_CONTRACT_DATE_ERROR = 'CUSTOMER_UPDATE_CONTRACT_DATE_ERROR';

export const CUSTOMER_DOWNLOAD_REQUEST = 'CUSTOMER_DOWNLOAD_REQUEST';
export const CUSTOMER_DOWNLOAD_REQUEST_SUCCESS = 'CUSTOMER_DOWNLOAD_REQUEST_SUCCESS';
export const CUSTOMER_DOWNLOAD_REQUEST_ERROR = 'CUSTOMER_DOWNLOAD_REQUEST_ERROR';
